(function () {
  function formatMoney(cents, moneyFormat) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, moneyFormat); } catch (e) {}
    }
    var value = (Number(cents || 0) / 100).toFixed(2);
    var format = moneyFormat || '${{amount}}';
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(Number(value)).toString())
      .replace(/\{\{\s*amount\s*\}\}/g, value)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','));
  }

  function getFormRoot(scriptEl) {
    var root = scriptEl.previousElementSibling;
    while (root && !root.classList.contains('t4s-swatch')) root = root.previousElementSibling;
    return root || scriptEl.closest('.t4s-product-form__variants') || document;
  }

  function getSelectedOptions(root, optionCount) {
    var selected = new Array(optionCount).fill('');
    root.querySelectorAll('[data-swatch-option]').forEach(function (group, index) {
      var item = group.querySelector('[data-swatch-item].is--selected') || group.querySelector('[data-swatch-item]');
      if (item) selected[index] = item.getAttribute('data-value') || item.textContent.trim();
    });
    return selected;
  }

  function findVariant(variants, options) {
    return variants.find(function (variant) {
      if (!variant || !variant.options) return false;
      for (var i = 0; i < options.length; i++) {
        if ((variant.options[i] || '') !== (options[i] || '')) return false;
      }
      return true;
    }) || null;
  }

  function autoDiscountText(variant, moneyFormat) {
    var compare = Number(variant && variant.compare_at_price || 0);
    var price = Number(variant && variant.price || 0);
    if (compare > price) return formatMoney(compare - price, moneyFormat).replace(/\.00\b/, '') + ' OFF';
    return '';
  }

  function priceHtml(variant, moneyFormat) {
    if (!variant) return '';
    var html = '<span class="fossibot-option-card__price-now">' + formatMoney(variant.price, moneyFormat) + '</span>';
    if (Number(variant.compare_at_price || 0) > Number(variant.price || 0)) {
      html += '<span class="fossibot-option-card__price-compare">' + formatMoney(variant.compare_at_price, moneyFormat) + '</span>';
    }
    return html;
  }

  function updateCards(root, data) {
    if (!root || !data || !Array.isArray(data.variants) || !data.variants.length) return;
    var optionCount = data.variants[0].options ? data.variants[0].options.length : 0;
    var selectedOptions = getSelectedOptions(root, optionCount);

    root.querySelectorAll('[data-fossibot-option-card]').forEach(function (card) {
      var position = parseInt(card.getAttribute('data-option-position') || '1', 10) - 1;
      var value = card.getAttribute('data-value') || '';
      var options = selectedOptions.slice();
      options[position] = value;
      var variant = findVariant(data.variants, options);
      if (!variant) return;

      var priceEl = card.querySelector('[data-fossibot-option-price]');
      if (priceEl) priceEl.innerHTML = priceHtml(variant, data.money_format);

      var saveEl = card.querySelector('[data-fossibot-option-save]');
      if (saveEl) {
        saveEl.textContent = (variant.discount_label || autoDiscountText(variant, data.money_format) || '').trim();
      }

      var badgeEl = card.querySelector('[data-fossibot-option-badge]');
      if (badgeEl) {
        badgeEl.textContent = (variant.badge || '').trim();
        badgeEl.classList.toggle('t4s-dn', !badgeEl.textContent);
      }

      if (variant.featured_image) {
        var img = card.querySelector('.fossibot-option-card__media img');
        if (img && img.getAttribute('src') !== variant.featured_image) img.setAttribute('src', variant.featured_image);
      }
    });
  }

  function initOne(scriptEl) {
    if (scriptEl.dataset.fossibotVariantCardsInit === '1') return;
    scriptEl.dataset.fossibotVariantCardsInit = '1';
    var data;
    try { data = JSON.parse(scriptEl.textContent); } catch (e) { return; }
    var root = getFormRoot(scriptEl);
    updateCards(root, data);

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-swatch-item]')) {
        window.setTimeout(function () { updateCards(root, data); }, 120);
        window.setTimeout(function () { updateCards(root, data); }, 450);
      }
    });

    root.addEventListener('change', function () { window.setTimeout(function () { updateCards(root, data); }, 120); });
    document.addEventListener('variant:change', function () { window.setTimeout(function () { updateCards(root, data); }, 120); });
  }

  function initAll() { document.querySelectorAll('script[data-fossibot-variant-card-data]').forEach(initOne); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
})();
